import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import TableContainer from "../../../components/Common/TableContainer";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const QuestionCoursesTable = ({ courses, showHideCourse, getCourses }) => {
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: (cellProps) => <b>{cellProps.cell.row.index + 1}</b>,
      },
      {
        Header: "Cover",
        accessor: "course_photo_url",
        Cell: ({ row }) => {
          const img = row.original.course_photo_url;
          return (
            <img
              src={img || require("../../../assets/images/noimage.png")}
              alt="Course"
              style={{
                width: "70px",
                height: "55px",
                objectFit: "cover",
                borderRadius: "6px",
                border: "1px solid #eee",
              }}
            />
          );
        },
      },
      {
        Header: "Course Name",
        accessor: "course_name",
        Cell: ({ row }) => (
          <div>
            <span className="fw-bold font-size-15 d-block text-primary">
              {row.original.course_name || "No Name"}
            </span>
            <small className="text-muted">
              Price: {row.original.course_price} JOD
            </small>
          </div>
        ),
      },
      {
        Header: "University / Grade",
        Cell: ({ row }) => (
          <div>
            <div>
              <i className="bx bx-buildings text-muted me-1"></i>
              {row.original.university_name || "N/A"}
            </div>
            <small className="text-muted">
              {row.original.grade_name || "N/A"}
            </small>
          </div>
        ),
      },
      {
        Header: "Question Units",
        Cell: ({ row }) => (
          <button
            className="btn btn-sm btn-info d-flex align-items-center gap-1"
            onClick={() =>
              navigate("/units", {
                state: {
                  coursedata: row.original,
                },
              })
            }
            title="Manage Units & Questions"
          >
            <i className="bx bx-layer"></i>
            <span>Manage Units</span>
          </button>
        ),
      },
      {
        Header: "Open Question Bank",
        Cell: ({ row }) => (
          <button
            className="btn btn-sm btn-success d-flex align-items-center gap-1"
            onClick={() =>
              navigate("/question-data/banks", {
                state: {
                  course_id: row.original.course_id,
                  coursedata: row.original,
                },
              })
            }
            title="Go to Question Bank filter"
          >
            <i className="bx bx-help-circle"></i>
            <span>Question Bank</span>
          </button>
        ),
      },
      {
        Header: "Status",
        Cell: ({ row }) => {
          const item = row.original;
          const isHidden = item.hidden === "yes" || item.course_hidden === "yes";
          return (
            <button
              className={`btn btn-sm ${
                isHidden ? "btn-soft-danger" : "btn-soft-success"
              }`}
              onClick={() =>
                showHideCourse({
                  course_id: item.course_id,
                  status: isHidden ? "no" : "yes",
                })
              }
              title={isHidden ? "Unhide Course" : "Hide Course"}
            >
              {isHidden ? (
                <span>
                  <i className="bx bx-hide me-1"></i> Hidden
                </span>
              ) : (
                <span>
                  <i className="bx bx-show me-1"></i> Visible
                </span>
              )}
            </button>
          );
        },
      },
    ],
    []
  );

  return (
    <TableContainer
      columns={columns}
      data={courses || []}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={10}
      className="custom-header-css align-middle table-nowrap"
      tableClassName="align-middle table-nowrap"
    />
  );
};

export default QuestionCoursesTable;
